import i18next from 'i18next';

export const getLocalizedText = (i18n: i18next.i18n, value: string): string => {
  return i18n.t([`enums.certificateType.${value.toUpperCase()}`, value]);
};

export const getIconCss = (type: string): string => {
  return `icon icon-certificate-type-${type.split('_').join('-').toLowerCase()}`;
}
